module.exports = __webpack_public_path__ + "static/Orange Siding - Cladding-2e5a8001c772883f6dcfe928931d7fdc.jpg";